<template>
  <el-dialog title="新建文件夹" :visible.sync="commandDialogVisible" width="50%">
    <el-form :model="form" :rules="rules" ref="form" label-width="100px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="文件夹名称" prop="name">
            <el-input v-model.trim="form.name"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancelFileFold('form')" plain>取 消</el-button>
      <el-button type="primary" plain @click="createFileFold('form')">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    var checkIdCard = (rule, value, callback) => {
      var regex = new RegExp("^[a-zA-Z0-9_-]+$");
      let flage = regex.test(value);
      if (flage) {
        callback();
      } else {
        callback("不能包含中文和除(_ -)之外所有的特殊字符");
      }
    };
    return {
      commandDialogVisible: false,
      form: {
        name: undefined,
        path: undefined,
      },
      rules: {
        name: [
          {
            required: true,
            message: "文件夹名称不为空",
            trigger: "blur",
          },
          { validator: checkIdCard, trigger: "blur" },
        ],
      },
    };
  },
  watch: {},
  methods: {
    showCreateFold(params) {
      this.commandDialogVisible = true;
      this.form.path = params.path;
    },
    createFileFold(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.http.post("/client/file/create-fold", this.form).then((res) => {
            console.log(res);
            let data = res.data;
            if (data.status && data.status == 500) {
              this.cancelFileFold();
              this.$emit("handleCreateSuccess", this.form);
              this.$notify({
                title: "失败",
                message: data.message,
                type: "error",
                duration: 2000,
              });
            } else {
              this.cancelFileFold();
              this.$emit("handleCreateSuccess", this.form);
              this.$notify({
                title: "成功",
                message: "创建成功",
                type: "success",
                duration: 2000,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    cancelFileFold() {
      this.commandDialogVisible = false;
      this.restFileFoldForm();
    },
    restFileFoldForm() {
      this.form = {
        name: undefined,
        path: undefined,
      };

      this.$refs["form"].resetFields();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/project2/components/file-transfer/CreateFold.vue